window.angular
    .module('MyHippoProducer.Components')
    .directive('inlineError', function () {
        return {
            restrict: 'E',
            scope: {errors: '<'},
            templateUrl: 'components/inline-error/inline-error.html',
        };
    });
